import _ChapterMediaLinkService from "../services/chapter-media-link-service";
import { IChapterMediaLinkService } from "../types/services/chapter-media-link-service";

const instance = new _ChapterMediaLinkService();

const ChapterMediaLinkService: IChapterMediaLinkService = instance;

export default ChapterMediaLinkService;
